module.exports = __webpack_public_path__ + "static/media/clock.c2aba9b3.svg";